import Bugsnag from '@bugsnag/js';

export function bugsnagNotify(error: Error | string, context: string) {
  try {
    error = error || 'Undefined Error';
    const errorMessage =
      (typeof error === 'string' ? error : error.message) || JSON.stringify(error) || '';
    const errorStack = typeof error === 'string' ? '' : error.stack || '';
    const errorName = typeof error === 'string' ? '' : error.name || '';
    Bugsnag.notify(new Error(`[${context}][${errorName}] ${errorMessage}\n${errorStack}`));
  } catch (e) {
    console.error(error);
    console.error(e);
  }
}
